import { render, staticRenderFns } from "./TaxExempt.vue?vue&type=template&id=4f63db74&lang=pug"
import script from "./TaxExempt.vue?vue&type=script&lang=js"
export * from "./TaxExempt.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports